// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import Router from "./router";
import store from "@store/index";
import VueRouter from "vue-router";
import flexible from "@common/js/flexible.js";
import MuseUI from "muse-ui";
import VueLazyload from "vue-lazyload"; //图片懒加载
import VueAwesomeSwiper from "vue-awesome-swiper"; //图片轮播
import apiPlugin from "./service/index";
import api from "./service/api";
import utilPlugin from "@common/utils/index";
import common from "@common/js/common.js";
import { initWxShare } from "@common/js/common.js";
import VueAMap from "vue-amap";
import * as filters from "./filters/index";
import wx from "weixin-js-sdk";
import { storage } from "@common/utils/util";
// import { Toast, Dialog, Radio, RadioGroup } from "vant";

//引入高德地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "4a30ddcd0a6a31f5763053428c0dad35",
  plugin: [
    "AMap.Autocomplete",
    "AMap.Geolocation",
    "AMap.PlaceSearch",
    "AMap.Geolocation",
    "AMap.CitySearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
    "AMap.AdvancedInfoWindow",
  ],
  uiVersion: "1.0", // 版本号
});

// 全局filter注册
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

/*引入css*/
import "@common/sass/common.scss";
import "../static/reset.css";
import "muse-ui/dist/muse-ui.css";
import "@common/sass/mixin.scss";
require("swiper/dist/css/swiper.css");

Vue.use(common); //引入公用js
/*插件注册*/
Vue.use(MuseUI);
Vue.use(VueAwesomeSwiper);
Vue.use(apiPlugin);
Vue.use(utilPlugin);

Vue.use(VueLazyload, {
  error: "/static/images/defaults/lazy-default.png", //失败后默认图
  loading: "/static/images/defaults/lazy-default.png", //loading过渡图
  try: 3, // 加载重试次数
});

//页面路由
Router().then((routerConfig) => {
  let router = new VueRouter({
    routes: routerConfig,
    mode: "history",
  });
  router.beforeEach((to, from, next) => {
    const skipWxAuth = to.meta && to.meta.skipWxAuth;
    if (!skipWxAuth) {
      // 微信分享
      initWxShare(to.fullPath);
    }

    //设置微信title
    if (to.meta.title) {
      let title = to.meta.title;
      document.title = title;
    } else {
      document.title = "美心门商城";
    }

    console.log(to.meta.title);
    //判断是否是在登陆售后系统之后进入其它板块，true时已经登录过售后系统
    let isCustomerService = storage.session.get("customerService");
    let cusToken = storage.session.get("cusToken");

    //当前为售后系统时，再次进入页面不需要清空storage，不需要重新登录
    //当在售后登陆之后，进入商城需要重新登陆
    if (!isCustomerService && to.meta.belong == "customerService" && cusToken) {
      storage.local.set("token", cusToken);
    } else if (isCustomerService && to.meta.belong != "customerService") {
      //当登录了售后系统之后再进入其他板块需要清空token和用户信息
      storage.local.remove("token");
      storage.local.remove("USERINFO");
      storage.session.set("customerService", false);
    }
    storage.local.set("belong", to.meta.belong || "");
    //alert('跳转至：' + to.fullPath + ' ,是否需要登录： ' + !!to.meta.requireAuth + ' ,是否自动登陆：' + !!to.query.autologin);
    if (to.meta.requireAuth || to.query.autologin) {
      if (to.query.autologin) {
        delete to.query.autologin;
      }

      //本地没有userAttrId 或者 userInfo 直接跳转到auth
      //TODO

      //调用api判断是否已登陆
      api.loginHanlder.checkLogin([]).then((res) => {
        console.log("res", res);
        if (res.success && res.target && res.target.success) {
          //alert('已登录，放行');

          //完整路径
          if (to.fullPath.includes("http")) {
            location.href = to.fullPath.startsWith("/")
              ? to.fullPath.substring(1)
              : to.fullPath;
          } else {
            next();
          }
        } else {
          let query = Object.assign({}, to.query, {
            redirect: to.fullPath,
          });

          if (to.meta.belong == "questions") {
            next({
              path: "/main/questionLogin",
              query: query,
            });
          } else {
            next({
              path:
                "/main/auth?isQuestionLogin=" +
                (to.meta.isQuestionLogin || "false"),
              query: query,
            });
          }
        }
      });
    } else {
      next();
    }
  });
  new Vue({
    el: "#app",
    router,
    store,
    render: (h) => h(App),
  });
});



// WEBPACK FOOTER //
// ./src/main.js